import { useEffect } from 'react';

export default function SEO({ title, description, keywords, schema }) {
  useEffect(() => {
    // 1. Update Title tag
    if (title) {
      document.title = title;
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute('content', title);
      const twitterTitle = document.querySelector('meta[name="twitter:title"]');
      if (twitterTitle) twitterTitle.setAttribute('content', title);
    }

    // 2. Update Description tag
    if (description) {
      const descTag = document.querySelector('meta[name="description"]');
      if (descTag) descTag.setAttribute('content', description);
      const ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.setAttribute('content', description);
      const twitterDesc = document.querySelector('meta[name="twitter:description"]');
      if (twitterDesc) twitterDesc.setAttribute('content', description);
    }

    // 3. Update Keywords tag
    if (keywords) {
      const keywordsTag = document.querySelector('meta[name="keywords"]');
      if (keywordsTag) keywordsTag.setAttribute('content', keywords);
    }

    // 4. Update Schema tag if present
    if (schema) {
      const existingSchema = document.getElementById('seo-dynamic-schema');
      if (existingSchema) existingSchema.remove();

      const script = document.createElement('script');
      script.id = 'seo-dynamic-schema';
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }

    // Cleanup function when page unmounts
    return () => {
      if (schema) {
        const el = document.getElementById('seo-dynamic-schema');
        if (el) el.remove();
      }
    };
  }, [title, description, keywords, schema]);

  return null;
}
